import { Role } from '@prisma/client';
import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@zond/ui';
import { useTranslation } from 'react-i18next';
import { MemberFormData } from '../types';

interface MemberRoleFormProps {
  value: MemberFormData;
  onChange: (value: MemberFormData) => void;
  className?: string;
}

export const MemberRoleForm = ({ value, onChange, className }: MemberRoleFormProps) => {
  const { t } = useTranslation('settings');
  return (
    <div className={className}>
      <div className="space-y-2">
        <Label htmlFor="role">{t('members.roleForm.label')}</Label>
        <Select value={value.role} onValueChange={(role) => onChange({ ...value, role: role as Role })}>
          <SelectTrigger>
            <SelectValue placeholder={t('members.roleForm.placeholder')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={Role.ADMIN}>{t('members.roles.admin')}</SelectItem>
            <SelectItem value={Role.USER}>{t('members.roles.user')}</SelectItem>
            <SelectItem value={Role.VIEWER}>{t('members.roles.viewer')}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
